import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface Session {
  uid?: string;
}

interface RedirectOnLoggedInProps {
  session: Session;
  children: React.ReactNode;
  redirectToPath: string;
}

const RedirectOnLoggedIn = function ({
  session,
  children,
  redirectToPath,
}: RedirectOnLoggedInProps) {
  const location = useLocation();
  const to = location.state?.from || redirectToPath;

  if (!session.uid) return children;
  return <Navigate replace to={to} />;
};

export default RedirectOnLoggedIn;
